<div class="bg-gradient">
  <div class="smm-container">
    <div
      class="footer__header flex flex-md-row flex-column justify-content-md-between justify-content-start align-items-start"
    >
      <div class="flex-column gap-1 footer__header__text">
        <div class="logo__container">
          <img ngSrc="/imgs/logo-dark.svg" width="140" height="50" alt="Echoza Logo" class="logo" />
        </div>
        <p class="caption__standard mb-4">
          {{ 'FOOTER.DESC' | translate }}
        </p>
      </div>
      <div class="social__media flex gap-2 align-items-center">
        <p class="highlight__standard follow-us">
          {{ 'FOOTER.FOLLOW_US' | translate }}
        </p>
        <div class="flex gap-2">
          <img
            ngSrc="/imgs/icons/facebook-icon.png"
            alt="Facebook Icon"
            width="20"
            height="20"
            class="social__media__icon"
          />
          <!-- <a href=""  rel="noopener noreferrer">
          </a> -->
          <img
            ngSrc="/imgs/icons/twitter-icon.png"
            alt="Twitter Icon"
            width="20"
            height="20"
            class="social__media__icon"
          />
          <!-- <a   rel="noopener noreferrer">
          </a> -->
          <img
            ngSrc="/imgs/icons/linked-icon.png"
            width="20"
            height="20"
            alt="LinkedIn Icon"
            class="social__media__icon"
          />
          <!-- <a
            
            rel="noopener noreferrer"
          >
          </a> -->
        </div>
      </div>
    </div>

    <div class="footer__body row between">
      <nav class="py-5 col-12 col-md-5">
        <div class="flex gap-6 flex-wrap">
          @for (section of footerSections; track section.header) {
            <div>
              <h3 class="footer-header highlight__standard mb-4">
                {{ section.header | translate }}
              </h3>
              <ul class="footer-list">
                @for (link of section.links; track link.label) {
                  <li>
                    @if (link.url) {
                      <a
                        [href]="link.url"
                        [target]="link.isExternal ? '_blank' : '_self'"
                        class="footer-link caption__standard"
                      >
                        {{ link.label | translate }}
                      </a>
                    } @else {
                      <a
                        (click)="handleNavClick(link.fragment ?? '')"
                        class="footer-link caption__standard cursor-pointer"
                      >
                        {{ link.label | translate }}
                      </a>
                    }
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      </nav>
      <!-- <div class="col-12 col-md-5">
        <smm-newsletter></smm-newsletter>
      </div> -->
    </div>

    <div
      class="footer__footer py-1 flex flex-md-row flex-column gap-2 justify-content-between align-items-md-center align-items-start"
    >
      <div class="flex flex-column gap-1">
        <p class="caption__standard">&copy; {{ 'FOOTER.COPYRIGHT' | translate }}</p>
        <p class="caption__standard">{{ 'FOOTER.PRODUCT_OF' | translate }}</p>
      </div>
      <div class="flex gap-1 align-items-center cursor-pointer" (click)="toggleLang()">
        <p>
          {{ 'FOOTER.LANG' | translate }}
        </p>
        <img
          ngSrc="/imgs/icons/language.png"
          width="20"
          height="20"
          alt="change lang icon"
          class="language__icon"
        />
      </div>
    </div>
  </div>
</div>
